export default (state, action) => {
  const { selection } = state;
  const { designId } = action.payload;
  return { ...state, selection: [...selection, designId] };
};
